/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TRecoverUserReplyTemplateRequest,
  TRecoverUserReplyTemplateModel,
  IMappers,
  TRecoverUserReplyTemplateResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ICreateUserReplyTemplatesListResponse } from '../../entities/reply_templates/CreateUserReplyTemplatesListResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createRecoverUserReplyTemplateModel(
  parameters: TRecoverUserReplyTemplateRequest,
): TRecoverUserReplyTemplateModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/recover-user-reply-template/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IRecoverUserReplyTemplateOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TRecoverUserReplyTemplateRequest;
}

export async function fetchRecoverUserReplyTemplate<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IRecoverUserReplyTemplateOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TRecoverUserReplyTemplateResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createRecoverUserReplyTemplateModel(parameters),
    config,
  )) as FetchResponse<TRecoverUserReplyTemplateResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateUserReplyTemplatesListResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TRecoverUserReplyTemplateResponse>;
}
